import { put, takeLatest } from "redux-saga/effects";
import axios, { AxiosError, AxiosResponse } from "axios";
import { signInSuccess, signInFailure } from "./slice";
import { SIGNIN_REQUEST, SignInResponseTypeWrapper } from "./types";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* signInUser(action: any) {
  try {
    const { username, password } = action.payload;
    const response: AxiosResponse<SignInResponseTypeWrapper> = yield axios.post(
      `${API_BASE_URL}/api/v1/auth/signin`,
      { username, password }
    );
    localStorage.setItem("accessToken", response?.data?.auth?.accessToken);
    localStorage.setItem("refreshToken", response?.data?.auth?.refreshToken);
    yield put(signInSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(signInFailure({ error: err.response?.data }));
  }
}

export function* signInSaga() {
  yield takeLatest(`${SIGNIN_REQUEST}/signInRequest`, signInUser);
}
